import { ITableColumn } from '@busybusy/webapp-react-ui';
import { t } from 'i18next';
import { IVisibleTableColumn } from 'types/TableColumn';
import { getFullNameFromMember } from 'utils/stringUtils';
import { CertificationStatusReportActiveSortableColumnKey } from '../CertificationColumnDialogs/CertificationStatusReportActiveColumnsDialog';
import { ICertificationStatusReportRowItem } from '../CertificationStatusReportTable/CertificationStatusReportTable';

export const defaultCertificationStatusReportActiveColumns: IVisibleTableColumn<CertificationStatusReportActiveSortableColumnKey>[] =
  [
    { key: 'member', title: 'member', visible: true },
    { key: 'certification', title: 'certification', visible: true },
    { key: 'issueDate', title: 'issueDate', visible: true },
    { key: 'expirationDate', title: 'expirationDate', visible: true },
    { key: 'renewal', title: 'renewal', visible: true },
  ];

export const certificationStatusReportActiveColumnLabelLookup: Record<
  CertificationStatusReportActiveSortableColumnKey,
  string
> = {
  member: t('Member'),
  certification: t('Certification'),
  issueDate: t('Issued/Renewed'),
  expirationDate: t('Expires'),
  renewal: t('Renewal'),
};

export const certificationStatusReportActiveColumnLookup: Record<
  CertificationStatusReportActiveSortableColumnKey,
  ITableColumn<ICertificationStatusReportRowItem>
> = {
  member: {
    key: 'member',
    title: certificationStatusReportActiveColumnLabelLookup.member,
    cell: (row: ICertificationStatusReportRowItem) => {
      return getFullNameFromMember(row.member);
    },
  },
  certification: {
    key: 'certification',
    title: certificationStatusReportActiveColumnLabelLookup.certification,
    cell: (row: ICertificationStatusReportRowItem) => row.certification?.name ?? '',
  },
  issueDate: {
    key: 'issueDate',
    title: certificationStatusReportActiveColumnLabelLookup.issueDate,
    cell: (row: ICertificationStatusReportRowItem) => row.issueDate ?? '',
  },
  expirationDate: {
    key: 'expirationDate',
    title: certificationStatusReportActiveColumnLabelLookup.expirationDate,
    cell: (row: ICertificationStatusReportRowItem) => row.expirationDate ?? '',
  },
  renewal: {
    key: 'renewal',
    title: certificationStatusReportActiveColumnLabelLookup.renewal,
    cell: (row: ICertificationStatusReportRowItem) => row.renewal ?? '',
  },
};

export const supportedCertificationAttachmentFileExtensions = ['png', 'jpg', 'jpeg', 'pdf', 'docx'] as const;

export const supportedCertificationAttachmentFileType = [
  'image/png',
  'image/jpg',
  'image/jpeg',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
] as const;

export type TSupportedCertificationAttachmentFileExtensions =
  (typeof supportedCertificationAttachmentFileExtensions)[number];

export type TSupportedCertificationAttachmentFileType = (typeof supportedCertificationAttachmentFileType)[number];

export const fileTypeToFileExtensionLookupCertificationAttachment: Record<
  TSupportedCertificationAttachmentFileType,
  TSupportedCertificationAttachmentFileExtensions
> = {
  'image/png': 'png',
  'image/jpg': 'jpg',
  'image/jpeg': 'jpeg',
  'application/pdf': 'pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
};
